export enum OrganizationDevicesTableColumn {
  SERIAL_NUMBER = 'serialNumber',
  PATIENT = 'patient',
  MENU = 'menu',
}

export enum OrganizationUsersTableColumn {
  NAME = 'name',
  EMAIL = 'email',
  ROLE = 'role',
  MENU = 'menu',
}
